import styled from 'styled-components';
import { COLORS } from '@/styles/colors';

export const SIZE = 46;
export const STROKE_WIDTH = 6;

export const ProgressWrapper = styled.div`
  position: relative;
  height: ${SIZE}px;
  width: ${SIZE}px;
  display: inline-block;
`;

export const ProgressCircle = styled.svg`
  transform: rotate(-90deg);
  width: 100%;
  height: 100%;
`;

export const ProgressCircleBack = styled.circle`
  fill: none;
  stroke: ${COLORS.grey[150]};
  stroke-width: 6px;
`;

export const ProgressCircleProgress = styled.circle`
  fill: none;
  stroke: ${COLORS.green[350]};
  stroke-linecap: round;
  transition: stroke-dasharray 0.3s ease-in-out;
  stroke-dashoffset: 0;
`;

export const ProgressText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
